import geoAPI from "../../../api/geoAPI";
import { urlContexts } from "../../../constants";

const resp:any = {
  headers: {},
  data: [
    {
      id: "001",
      code: "Lorem ipsum",
      name: "Lorem ipsum",
      description: "Lorem ipsum",
      layerImage: "Lorem ipsum dolor",
      layerName: "Lorem ipsum dolor"
    },
    {
      id: "002",
      code: "Lorem ipsum",
      name: "Lorem ipsum",
      description: "Lorem ipsum",
      layerImage: "Lorem ipsum dolor",
      layerName: "Lorem ipsum dolor"
    },
    {
      id: "003",
      code: "Lorem ipsum",
      name: "Lorem ipsum",
      description: "Lorem ipsum",
      layerImage: "Lorem ipsum dolor",
      layerName: "Lorem ipsum dolor"
    },
  ]
};

export const getMasters = async (tenantid: string) => {
  const { data } = await geoAPI.get(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/pointsServicesTypes`,
        {
          headers: {
            tenant: tenantid
          }
        }
      );

  return data;
};

export const createMasters = async (body: any, tenantid: string) => {
  const { data } = await geoAPI.post(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/pointsServicesTypes`,{
          name: body.name,
          code: body.code,
          description: body.description,
          statusId: 1,
          file: body.pointServiceImage,
          layerName: body.layerName,
        },
        {
          headers: {
            "Content-Type": "multipart/form-data",
            tenant: tenantid
          }
        }
      );

  return data;
};

export const updateMasters = async (body: any, tenantid: string) => {
  let dataFormatted:any = {
    name: body.name,
    code: body.code,
    description: body.description,
    statusId: 1,
    layerName: body.layerName,
  }
  dataFormatted = body.pointServiceImage ? {...dataFormatted, file: body.pointServiceImage } : {...dataFormatted}
  const { data } = await geoAPI.put(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/pointsServicesTypes/${body.id}`,
        dataFormatted,
        {
          headers: {
            "Content-Type": "multipart/form-data",
            tenant: tenantid
          }
        }
      );

  return data;
};

export const deleteMasters = async (id: number, tenantid: string) => {
  const { data } = await geoAPI.delete(
        `${process.env['REACT_APP_BACKEND_GEO_HOST'] ||
          (process.env['REACT_APP_BACKEND_HOST']+'/'+urlContexts.servicepoint)
        }/iuvibanking-point-service-api/rest/1.0/pointsServicesTypes/${id}`,
        {
          headers: {
            tenant: tenantid
          }
        }
      );

  return data;
};
